import React from 'react';
import { Input, Select } from '@fourthwall/components';
import { FormFields } from '../../hooks/useBadgeForm/types';
import { RuleLayout } from '../RuleLayout';
export const GiftsGivenRule = ({ form, options }) => (React.createElement(RuleLayout, { top: React.createElement(Select, { value: 'GiftsGiven', label: "Requirement to earn badge", options: options, onValueChange: (value) => {
            const newRules = form.values.rules.map((rule) => rule.type === 'GiftsGiven' ? { type: value } : rule);
            form.setFieldValue(FormFields.rules, newRules);
        } }), bottom: React.createElement(React.Fragment, null,
        React.createElement(Input, { ...form.getFieldProps(FormFields.gifsGivenMin), label: "Min. gifts number" }),
        React.createElement(Input, { ...form.getFieldProps(FormFields.gifsGivenMax), label: "Max. gifts number", suggestion: "Leave empty for infinite" })), onRemove: () => {
        form.setFieldValue(FormFields.rules, form.values.rules.filter((rule) => rule.type !== ('GiftsGiven')));
    } }));
